import usePrivateAxios from "@/common/api/usePrivateAxios"
import Box from "@/common/components/Box"
import Button from "@/common/components/Button"
import TextField from "@/common/components/TextField"
import { ChevronsRight } from "lucide-react"
import { Link, useNavigate, useParams } from "react-router-dom"
import { useMutation } from "@tanstack/react-query"
import Modal from "@/common/components/Modal"
import useProductCategory from "../../hooks/useProductCategory"
import GoBackButton from "@/common/components/GoBackButton";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper"

const Show = () => {
  const navigate = useNavigate()
  const privateAxios = usePrivateAxios();
  const { id } = useParams();

  const {
    data: productCategory,
    isPending,
    error: requestError = {} as any,
    refetch: refetchRequest,
  } = useProductCategory(id || '');

  const { mutate: deleteProductCategory } = useMutation({
    mutationKey: ['deleteProductCategory'],
    mutationFn: () => privateAxios.delete(`/product_categories/${id}`),
    onSuccess: () => navigate('/product-categories')
  })

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-2 items-center">
          <GoBackButton fallback="/product-categories" />
          <p className="text-white-400 font-normal">Categoria de Produtos</p>

          {productCategory && (
            <>
              <ChevronsRight color='#ffffffb3' />
              <h2>{productCategory?.display_name}</h2>
            </>
          )}
        </div>
        <div className="flex gap-4">
          {productCategory?.products_count === 0
            ? <Modal
              Trigger={<Button operationKlassToCheckPermission="Admin::ProductCategories::Destroy" variant='outline-error'>Deletar</Button>}
              useCancellableFooter
              title='Tem certeza que deseja deletar a categoria?'
              onConfirm={deleteProductCategory}
            />
            : null}

          <Link to={`/product-categories/${id}/edit`}>
            <Button
              name="access_product_categories_show"
              operationKlassToCheckPermission="Admin::ProductCategories::Update"
              className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]"
              disabled={!productCategory}
            >
              Editar
            </Button>
          </Link>
        </div>
      </div>

      {isPending ? (
        <Box>
          Carregando...
        </Box>
      ) : (
        <ErrorMessageWrapper
          className="max-h-[calc(100vh-128px)]"
          statusCode={requestError?.status}
          refetchFunction={refetchRequest}
        >
          <Box className="flex flex-col gap-4 shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]">
            <p className="text-lg font-bold">{productCategory?.display_name}</p>
            <TextField
              disabled
              label="Nome da categoria"
              value={productCategory?.display_name || ''}
              data-testid='display_name_input'
            />
          </Box>
        </ErrorMessageWrapper>
      )}
    </div>
  )
}

export default Show
